import React from 'react';
import {Loader, SingleSelect} from 'sulu-admin-bundle/components';

class PromptSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            options: [],
            loading: true,
            error: null,
        };
    }

    componentDidMount() {
        fetch('/admin/ai-editor-prompts', {
            method: 'POST',
            body: JSON.stringify({uuid: this.props.uuid})
        }).then((response) => {
            return response.json();
        }).then((result) => {
            this.setState({
                options: result,
                loading: false
            });
        }).catch((error) => {
            this.setState({
                error: error.message,
                loading: false
            });
        });
    }

    handleChange = (selectedValue) => {
        this.props.onChange(selectedValue);
    };

    render() {
        const {loading, error, options} = this.state;

        return (
            <>
                {loading && <Loader />}
                {error && <p style={{ color: 'red' }}>{error}</p>}
                {!loading && !error && (
                    <SingleSelect
                        value={this.props.value}
                        onChange={this.handleChange}
                    >
                        {options.map(({ id, label, value }) => (
                            <SingleSelect.Option key={`key-` + id} value={value}>
                                {label}
                            </SingleSelect.Option>
                        ))}
                    </SingleSelect>
                )}
            </>
        );
    }
}

export default PromptSelect;